import * as $ from 'jquery';

interface RequestOptions {
    method: 'GET' | 'POST' | 'PUT' | 'DELETE';
    body?: any;
}

const globalUrl = typeof window['__API_URL__'] !== 'undefined' ? window['__API_URL__'] : '';
if (typeof window['__API_URL__'] !== 'undefined') {
    delete window['__API_URL__'];
}

export default (function() {
    const request = (url: string, options: RequestOptions) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: globalUrl + url,
                type: options.method,
                dataType: 'JSON',
                data: typeof options['body'] !== 'undefined' ? options.body : null,
                success: json => {
                    if (typeof json.code !== 'undefined' && json.code === 200) {
                        if (typeof json.pagination !== 'undefined') {
                            resolve({
                                items: json.data,
                                total: json.pagination.total
                            });
                        }
                        else {
                            resolve(json.data);
                        }
                    }
                    else {
                        if (json.msg) {
                            reject(json.msg);
                        }
                        else {
                            reject('Internal server error');
                        }
                    }
                },
                error: (xhr, textStatus, errorThrown) => {
                    if (xhr.responseJSON && typeof xhr.responseJSON['msg'] !== 'undefined') {
                        reject(xhr.responseJSON.msg);
                    }
                    else {
                        reject(errorThrown);
                    }
                }
            });
        });
    }

    const get = (url: string) => {
        return request(url, { method: 'GET' });
    }

    const post = (url: string, body: any) => {
        return request(url, { method: 'POST', body });
    }

    return {
        get,
        post
    };
})();



// WEBPACK FOOTER //
// ./src/api/fetch.service.ts